import type { Field } from "../types/field";

type Props = {
  fileName: string;
  data: Field[];
};
export const exportJson = ({ fileName, data }: Props) => {
  // オブジェクトをJSON文字列に変換
  const fileType = "application/json";

  const json = JSON.stringify(data);
  const blob = new Blob([json], { type: fileType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.download = fileName;
  link.target = "_blank";
  link.href = url;
  link.click();
  return;
};
